import { useState } from 'react'
import { Button, Modal } from '@eltoro-ui/components'
import { PixelFormItem } from 'Components'

export const PixelRejectionModal = ({
  onClose,
  onReject,
}: {
  onClose: () => void
  onReject: (rejectionReason: string) => void
}) => {
  const [rejectionReason, setRejectionReason] = useState('')
  const [customReason, setCustomReason] = useState('')

  const submitDisabled =
    !rejectionReason || (rejectionReason === 'Other' && !customReason)

  return (
    <Modal offClick={onClose} header="Reject Pixel" className="min-w-[500px]">
      <div className="PixelSelectOrCreateNew flex flex-col gap-3 p-2">
        <PixelFormItem
          htmlFor="pixel-rejection-reason"
          label="Select Rejection Reason"
          required
        >
          <select
            required
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            className="text-grey-500 border-tint-gray-200 w-full rounded-md border p-2 pr-3"
          >
            <option value="" disabled>
              Select a reason...
            </option>
            {[
              { id: 'invalid-url', name: 'Invalid URL' },
              { id: 'domain-not-accessible', name: 'Domain not accessible' },
              { id: 'security-concerns', name: 'Security concerns' },
              { id: 'duplicate-pixel', name: 'Duplicate pixel' },
              {
                id: 'violates-terms-of-service',
                name: 'Violates terms of service',
              },
              { id: 'other', name: 'Other' },
            ].map((option) => (
              <option
                key={option.id}
                value={option.name}
                data-testid={`option-${option.id}`}
              >
                {option.name}
              </option>
            ))}
          </select>
        </PixelFormItem>

        {rejectionReason === 'Other' && (
          <PixelFormItem
            htmlFor="rejection-reason"
            label="Custom reason"
            required
          >
            <textarea
              required
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />
          </PixelFormItem>
        )}
        <div className="flex items-center justify-end gap-2">
          <Button onClick={onClose}>Cancel</Button>
          <span
            data-tooltip="top"
            aria-label={submitDisabled ? 'Please select a reason' : undefined}
          >
            <Button
              onClick={() => {
                onReject(
                  rejectionReason === 'Other' ? customReason : rejectionReason,
                )
                onClose()
              }}
              className={`hover:!bg-danger-700 hover:!border-danger-700 !text-white${
                submitDisabled ? ' !cursor-not-allowed' : ''
              }`}
              kind="danger"
              disabled={submitDisabled}
            >
              Reject Pixel
            </Button>
          </span>
        </div>
      </div>
    </Modal>
  )
}
